import axios from "axios";
import React, { useEffect, useState } from "react";
import endPoint from "../../websitecomponents/redux/EndPoint/endpoint";
import { toast } from "react-toastify";
import SellerLoader from "../Util/SellerLoader";
import apiConfig from "../../apiConfig";

const CATEGORIES = ["Mobile", "Laptop", "TV"];
const BRANDS = ["Samsung", "Apple", "MI"];
const SPEC_KEYS = ["RAM", "Storage", "Battery", "Color"];

const InputField = ({ label, ...props }) => (
    <div>
        <label className="block text-sm font-semibold mb-1 text-gray-700">
            {label}
        </label>
        <input
            {...props}
            className="w-full border border-gray-300 px-3 py-2 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
        />
    </div>
);

const AddProduct = () => {
    const [loading, setLoading] = useState(false);
    const [selectedParentId, setSelectedParentId] = useState("");
    const [parentIds, setParentIds] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [selectedSubcategory, setSelectedSubcategory] = useState("");
    const [brands, setBrands] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState("");
    const [specifications, setSpecifications] = useState([]);
    const [specificationEntries, setSpecificationEntries] = useState([]);
    const [formData, setFormData] = useState({
        title: "",
        category: "",
        price: "",
        regularPrice: "",
        salePrice: "",
        stock: "",
        sku: "",
        gtin: "",
        sizes: [],
        description: "",
        specifications: [],
        productImages: [],
        variations: [
            {
                variationTitle: "",
                color: "",
                price: "",
                stock: "",
                images: []        // variation images
            }
        ],
    });

    useEffect(() => {
        const fetchSpecifications = async () => {
            try {
                const response = await axios.get(
                    `${apiConfig.baseUrl}/admin/GetAllspecificationkeys`
                );
                if (response.data && Array.isArray(response.data.data)) {
                    setSpecifications(response.data.data.map((spec) => spec.key));
                } else {
                    console.error(
                        "Specifications data is not an array or is missing:",
                        response.data
                    );
                    setSpecifications([]);
                }
            } catch (error) {
                console.error("Error fetching specifications:", error);
                setSpecifications([]);
            }
        };

        fetchSpecifications();
    }, []);

    useEffect(() => {
        const fetchParentIds = async () => {
            try {
                const response = await axios.get(
                    `${apiConfig.baseUrl}${apiConfig.getCategory}`
                );
                setParentIds(response.data);
                if (response.data.length > 0) {
                    setSelectedParentId(response.data[0]._id);
                }
            } catch (error) {
                console.error("Error fetching parent IDs:", error);
            }
        };

        fetchParentIds();
    }, []);

    useEffect(() => {
        const fetchSubcategories = async () => {
            try {
                if (selectedParentId) {
                    const response = await axios.get(
                        `${apiConfig.baseUrl}${apiConfig.getSubCategory}${selectedParentId}`
                    );
                    setSubcategories(response.data);

                }
            } catch (error) {
                console.error("Error fetching subcategories:", error);
            }
        };

        fetchSubcategories();
    }, [selectedParentId]);

    useEffect(() => {
        const fetchBrands = async () => {
            try {
                const response = await axios.get(
                    `${apiConfig.baseUrl}${apiConfig.GetAllBrands}`
                );
                setBrands(response.data);

                if (response.data.length > 0) {
                    setSelectedBrand("");
                }
            } catch (error) {
                console.error("Error fetching brands:", error);
            }
        };

        fetchBrands();
    }, []);

    const handleAddSpecification = () => {
        setSpecificationEntries((prevEntries) => [
            ...prevEntries,
            { key: "", values: [""] },
        ]);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "category") {
            const selectedCategory = parentIds.find(
                (category) => category.name === value
            );
            setSelectedParentId(selectedCategory ? selectedCategory._id : "");
        }
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const addSize = () =>
        setFormData({ ...formData, sizes: [...formData.sizes, ""] });

    const updateSize = (i, value) => {
        const sizes = [...formData.sizes];
        sizes[i] = value;
        setFormData({ ...formData, sizes });
    };

    const addSpecification = () =>
        setFormData({
            ...formData,
            specifications: [...formData.specifications, { key: "", value: "" }],
        });

    const updateSpecification = (i, field, value) => {
        const specs = [...formData.specifications];
        specs[i][field] = value;
        setFormData({ ...formData, specifications: specs });
    };

    const handleRemoveSpecification = (index) => {
        setSpecificationEntries((prevEntries) =>
            prevEntries.filter((_, i) => i !== index)
        );
    };


    const handleSpecificationChange = (index, event) => {
        const { value } = event.target;
        setSpecificationEntries((prevEntries) =>
            prevEntries.map((entry, i) =>
                i === index ? { ...entry, key: value } : entry
            )
        );
    };

    const handleValueChange = (specIndex, valueIndex, event) => {
        const { value } = event.target;
        setSpecificationEntries((prevEntries) =>
            prevEntries.map((entry, i) =>
                i === specIndex
                    ? {
                        ...entry,
                        values: entry.values.map((val, j) =>
                            j === valueIndex ? value : val
                        ),
                    }
                    : entry
            )
        );
    };

    const handleRemoveValue = (specIndex, valueIndex) => {
        setSpecificationEntries((prevEntries) =>
            prevEntries.map((entry, i) =>
                i === specIndex
                    ? {
                        ...entry,
                        values: entry.values.filter((_, j) => j !== valueIndex),
                    }
                    : entry
            )
        );
    };


    const handleAddValue = (index) => {
        setSpecificationEntries((prevEntries) =>
            prevEntries.map((entry, i) =>
                i === index ? { ...entry, values: [...entry.values, ""] } : entry
            )
        );
    };


    const addVariation = () =>
        setFormData({
            ...formData,
            variations: [
                ...formData.variations,
                { variationTitle: "", color: "", price: "", stock: "" },
            ],
        });

    const handleSubmit = async () => {
        if (!formData.title?.trim()) {
            return toast.error("Product Title is required");
        }
        if (!formData.category) {
            return toast.error("Category is required");
        }
        if (brands.length > 0 && !selectedBrand) {
            return toast.error("Brand is required");
        }
        if (!formData.regularPrice || isNaN(formData.regularPrice)) {
            return toast.error("Regular Price must be a number");
        }
        if (!formData.salePrice || isNaN(formData.salePrice)) {
            return toast.error("Sale Price must be a number");
        }
        if (!formData.stock || isNaN(formData.stock)) {
            return toast.error("Stock must be a number");
        }
        if (formData.productImages.length < 3) {
            return toast.error("At least 3 product images are required");
        }
        if (formData?.description.trim().length === 0) {
            return toast.error("Product Description is required");
        }
        if (formData?.selectedSubcategory?.trim().length === 0) {
            return toast.error("Subcategory is required");
        }

        try {
            setLoading(true);
            const token = localStorage.getItem("SellerTokenData");
            const formPayload = new FormData();

            formPayload.append("title", formData.title);
            formPayload.append("description", formData.description);
            formPayload.append("regularPrice", formData.regularPrice);
            formPayload.append("salePrice", formData.salePrice);
            formPayload.append("category", formData.category);
            formPayload.append("subcategory", selectedSubcategory);
            formPayload.append("brand", selectedBrand);
            formPayload.append("stock", formData.stock);
            formPayload.append("sku", formData.sku);
            formPayload.append("gtin", formData.gtin);

            formData.productImages.forEach((img, i) => {
                formPayload.append(`productimage${i + 1}`, img);
            });

            formData.variations.forEach((v, vIndex) => {
                formPayload.append(`variations[${vIndex}][variationTitle]`, v.variationTitle);
                formPayload.append(`variations[${vIndex}][color]`, v.color);
                formPayload.append(`variations[${vIndex}][price]`, v.price);
                formPayload.append(`variations[${vIndex}][stock]`, v.stock);

                v.images?.forEach((img, imgIndex) => {
                    formPayload.append(
                        `variationImage${imgIndex + 1}_${vIndex}`,
                        img
                    );
                });
            });
            await axios.post(endPoint.SellerAddProduct, formPayload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            toast.success("✅ Product Added Successfully");
            setLoading(false);
            setSelectedBrand("");
            setSelectedSubcategory("");
            setFormData({
                variationTitle: "",
                category: "",
                brand: "",
                price: "",
                regularPrice: "",
                salePrice: "",
                stock: "",
                sku: "",
                gtin: "",
                sizes: [],
                specifications: [],
                productImages: [],
                title: "",
                description: "",
                variations: [
                    {
                        title: "",
                        color: "",
                        price: "",
                        stock: "",
                        images: []
                    }
                ],
            });

        } catch (error) {
            console.error(error);
            toast.error("❌ Product upload failed");
        }
        finally {
            setLoading(false);
        }
    };

    const removeSpecification = (i) => {
        const specs = formData.specifications.filter(
            (_, index) => index !== i
        );
        setFormData({ ...formData, specifications: specs });
    };


    const removeSize = (i) => {
        const sizes = formData.sizes.filter((_, index) => index !== i);
        setFormData({ ...formData, sizes });
    };

    const handleProductImages = (e) => {
        const files = Array.from(e.target.files);
        const currentImages = [...formData.productImages];

        // Check if adding these files exceeds 3
        if (currentImages.length + files.length > 3) {
            toast.error("Maximum 3 images allowed");
            return;
        }

        setFormData({ ...formData, productImages: [...currentImages, ...files] });
    };

    const updateVariationField = (index, field, value) => {
        const updatedVariations = [...formData.variations];
        updatedVariations[index][field] = value;
        setFormData({ ...formData, variations: updatedVariations });
    };

    const handleVariationImages = (index, e) => {
        const files = Array.from(e.target.files);
        const updatedVariations = [...formData.variations];
        updatedVariations[index].images = files;
        setFormData({ ...formData, variations: updatedVariations });
    };


    const removeProductImage = (index) => {
        const updatedImages = formData.productImages.filter((_, i) => i !== index);
        setFormData({ ...formData, productImages: updatedImages });
    };

    return (
        <div className="min-h-screen to-indigo-100 flex justify-center items-start py-10 px-4">
            <div className="w-full bg-white rounded-xl ">
                {/* BASIC INFO */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <InputField label="Product Title" name="title" value={formData?.title} onChange={handleChange} />
                    <InputField
                        label="Regular Price"
                        name="regularPrice"
                        value={formData.regularPrice}
                        onChange={handleChange}
                    />

                    <InputField
                        label="Sale Price"
                        name="salePrice"
                        value={formData.salePrice}
                        onChange={handleChange}
                    />
                    <InputField label="Stock" name="stock" value={formData.stock} onChange={handleChange} />
                    <InputField label="SKU" name="sku" value={formData.sku} onChange={handleChange} />
                    <InputField label="GTIN" name="gtin" value={formData.gtin} onChange={handleChange} />

                    {/* <div>
                        <label className="block text-sm font-semibold mb-1">Category</label>
                        <select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            className="w-full border px-3 py-2 rounded-md"
                        >
                            <option value="">Select Category</option>
                            {CATEGORIES.map((c) => (
                                <option key={c}>{c}</option>
                            ))}
                        </select>
                    </div> */}

                    <div className="form-group mb-3">
                        <label htmlFor="category">Category</label>
                        <select
                            id="category"
                            name="category"
                            className="form-control"
                            value={formData.category}
                            onChange={handleChange}
                        >
                            <option value="">Select Category</option>
                            {parentIds.map((parent) => (
                                <option key={parent._id} value={parent.name}>
                                    {parent.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group mb-3">
                        <label htmlFor="subcategory">Subcategory</label>
                        <select
                            id="subcategory"
                            name="subcategory"
                            className="form-control"
                            value={selectedSubcategory}
                            onChange={(e) => setSelectedSubcategory(e.target.value)}
                        >
                            <option value="">Select Subcategory</option>
                            {subcategories?.map((subcategory) => (
                                <option key={subcategory?._id} value={subcategory.name}>
                                    {subcategory.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group mb-3">
                        <label htmlFor="brand">Brand</label>
                        <select
                            id="brand"
                            name="brand"
                            className="form-control"
                            value={selectedBrand}
                            onChange={(e) => setSelectedBrand(e.target.value)}
                        >
                            <option value="">Select Brand</option>
                            {brands?.map((brand) => (
                                <option key={brand.name} value={brand.name}>
                                    {brand.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="md:col-span-2">
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                            Description
                        </label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows={5}
                            className="w-full border border-gray-300 px-3 py-2 rounded-md resize-none focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                            placeholder="Enter product description..."
                        />
                    </div>

                </div>

                <div className="mt-10 border rounded-lg p-5 bg-gray-50">
                    <h2 className="font-semibold mb-3 text-lg">Sizes</h2>
                    {formData.sizes.map((s, i) => (
                        <div key={i} className="flex gap-2 mb-2">
                            <input
                                value={s}
                                placeholder="Size"
                                className="border p-2 w-full rounded"
                                onChange={(e) => updateSize(i, e.target.value)}
                            />
                            <button
                                onClick={() => removeSize(i)}
                                className="px-3 bg-red-500 text-white rounded"
                            >
                                −
                            </button>
                        </div>
                    ))}
                    <button onClick={addSize} className="text-indigo-600 font-medium">
                        + Add Size
                    </button>
                </div>

                {specificationEntries?.map((specification, specIndex) => (
                    <div key={specIndex} className="mb-2">
                        <div className="d-flex mb-2">
                            <select
                                className="form-control me-2"
                                value={specification?.key}
                                onChange={(event) =>
                                    handleSpecificationChange(specIndex, event)
                                }
                            >
                                <option value="">Select Key</option>
                                {specifications.map((specKey) => (
                                    <option key={specKey} value={specKey}>
                                        {specKey}
                                    </option>
                                ))}
                            </select>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleRemoveSpecification(specIndex)}
                            >
                                Remove Specification
                            </button>
                        </div>
                        {specification?.values.map((value, valueIndex) => (
                            <div key={valueIndex} className="d-flex mb-2">
                                <input
                                    type="text"
                                    placeholder="Value"
                                    className="form-control me-2"
                                    value={value}
                                    onChange={(event) =>
                                        handleValueChange(specIndex, valueIndex, event)
                                    }
                                    required
                                />
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => handleRemoveValue(specIndex, valueIndex)}
                                >
                                    Remove Value
                                </button>
                            </div>
                        ))}
                        <button
                            type="button"
                            className="btn btn-primary mb-2"
                            onClick={() => handleAddValue(specIndex)}
                        >
                            Add Value
                        </button>
                    </div>
                ))}

                <div className="mt-8 border rounded-lg p-5 bg-gray-50">
                    <h2 className="font-semibold mb-3 text-lg">Variations</h2>
                    {formData?.variations.map((v, i) => (
                        <div key={i} className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-4">
                            <input
                                className="border p-2 rounded"
                                placeholder="Title"
                                value={v.title}
                                onChange={(e) => updateVariationField(i, "title", e.target.value)}
                            />
                            <input
                                className="border p-2 rounded"
                                placeholder="Color"
                                value={v.color}
                                onChange={(e) => updateVariationField(i, "color", e.target.value)}
                            />
                            <input
                                className="border p-2 rounded"
                                placeholder="Price"
                                numericonly
                                value={v.price}
                                onChange={(e) => updateVariationField(i, "price", e.target.value)}
                            />
                            <input
                                className="border p-2 rounded"
                                placeholder="Stock"
                                numericonly
                                value={v.stock}
                                onChange={(e) => updateVariationField(i, "stock", e.target.value)}
                            />

                            <input
                                type="file"
                                multiple
                                accept="image/*"
                                onChange={(e) => handleVariationImages(i, e)}
                            />
                        </div>
                    ))}

                    <button onClick={addVariation} className="text-indigo-600 font-medium">
                        + Add Variation
                    </button>
                </div>

                <div className="grid grid-cols-3 gap-4 mt-5">
                    {formData?.productImages.map((img, index) => (
                        <div
                            key={index}
                            className="relative group rounded-lg overflow-hidden border hover:shadow-lg transition h-32"
                        >
                            <img
                                src={URL.createObjectURL(img)}
                                alt={`Product ${index + 1}`}
                                className="w-full h-full object-cover"
                            />

                            <button
                                type="button"
                                onClick={() => removeProductImage(index)}
                                className="absolute top-1 right-1 bg-red-600 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                                ✕
                            </button>
                        </div>
                    ))}

                    {formData.productImages.length < 3 && (
                        <label className="flex justify-center items-center border border-dashed rounded-lg cursor-pointer h-32 hover:bg-gray-100 transition">
                            <input
                                type="file"
                                multiple
                                accept="image/*"
                                className="hidden"
                                onChange={handleProductImages}
                            />
                            <span className="text-gray-400">+ Add Image</span>
                        </label>
                    )}
                </div>
                <button
                    onClick={handleSubmit}
                    className="mt-10 bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg w-full text-lg font-semibold"
                >
                    Add Product
                </button>
            </div>
            {loading && (<SellerLoader />)}
        </div>
    );
};

export default AddProduct;
